import { createContext } from 'react';

// สวิตช์เดียวคุมทั้งแผง (โหมด "แสดงสูตร") — Row/EditableRow ทุกตัวอ่านค่าจาก context นี้แทนการรับ
// prop showFormula ซ้ำๆ ทุกจุดเรียกใช้ (มีเป็นสิบจุดในไฟล์นี้)
export const ShowFormulaContext = createContext(false);
export const ColumnWidthContext = createContext({ valueWidth: null, pctWidth: null });

// ให้ EditableRow กด Enter แล้วเลื่อน focus ไปช่องกรอกถัดไปในลำดับ (tabOrder) ได้ต่อเนื่อง
// โดยไม่ต้องรู้จักกันโดยตรง — ลงทะเบียน startEdit ของตัวเองไว้ที่นี่ ให้ตัวก่อนหน้าเรียกต่อได้
export const EditableFieldRegistryContext = createContext(null);
